import { render } from "./ClockGUI.vue?vue&type=template&id=20da5e15&scoped=true"
import script from "./ClockGUI.vue?vue&type=script&lang=js"
export * from "./ClockGUI.vue?vue&type=script&lang=js"

import "./ClockGUI.vue?vue&type=style&index=0&id=20da5e15&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20da5e15"]])

export default __exports__